/**
 * AuthContext — 현재 로그인 사용자의 역할 + 접근 권한 config 를 앱 전역에 제공.
 *
 * Provider 는 AuthGate(승인된 사용자) 가 감싼다. Provider 가 없을 때(=AUTH 미설정,
 * 공용 비밀번호 모드)의 기본값은 owner + 기본 access — 기존처럼 전 메뉴가 보인다.
 * access = 기능별 최소 역할 config(사장이 직원 관리에서 조정, app_config/access).
 */
import { createContext, useContext } from "react";
import { DEFAULT_ACCESS, DEFAULT_DENY, canAccess } from "./access";

export const AuthContext = createContext({
  role: "owner", email: "", status: "approved", authEnabled: false,
  access: DEFAULT_ACCESS, deny: DEFAULT_DENY,
});

export function useAuth() {
  return useContext(AuthContext);
}

/** 현재 역할만 필요할 때. */
export function useRole() {
  return useContext(AuthContext).role;
}

/** 접근 권한 config(기능키→최소역할). */
export function useAccess() {
  return useContext(AuthContext).access || DEFAULT_ACCESS;
}

/** 기능별 역할 제외(#56 — 진현은 등급과 무관하게 계약 계열 제외). */
export function useDeny() {
  return useContext(AuthContext).deny || DEFAULT_DENY;
}

/** 게이트 단일 진입점 — 등급 임계 + 제외를 함께 본다. */
export function useCan() {
  const ctx = useContext(AuthContext);
  return (key) => canAccess(ctx.role, key, ctx.access || DEFAULT_ACCESS,
                            ctx.deny || DEFAULT_DENY);
}
